// DeleteDevicePopup.js
import React from "react";
import "../../features/devices/components/DeleteDevice.css";

const DeleteEmployeePopup = ({ onClose, onDelete, selectedEmployee ,isDeleting}) => {
  const handleDelete = () => {
    onDelete();
  };
  

  return (
    <div className="delete-device-popup-container">
      <div className="delete-device-header-container">
        <h3 className="delete-device-title">Delete Employee</h3>
        <button className="delete-device-cancel-button" onClick={onClose}>
          ✖
        </button>
      </div>
      <div className="delete-device-content-container">
        <p>
          Are you sure you want to delete this employee?
          <br />
          <br />
          <strong>Employee Name:</strong> {selectedEmployee?.first_name } {selectedEmployee?.last_name}
        </p>
        <div className="delete-device-form-actions">
          <button
            className="delete-device-delete-button"
            onClick={handleDelete}
            disabled={isDeleting} 
          >
             {isDeleting ? (
              <span className="spinner-small"></span> // show loader
            ) : (
              "Delete"
            )}
          </button>
          <button className="delete-device-cancel-button" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteEmployeePopup;
